










export default {
  data() {
    return {
      showingFen: false,
    }
  },

  methods: {
    toggleFen() {
      this.showingFen = !this.showingFen
    },
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/position_info.vue